export default {
  'common': {
    'add': 'Hinzufügen',
    'cancel': 'Stornieren',
    'description': 'Beschreibung',
    'delete': 'Löschen',
    'title': 'Titel',
    'save': 'sparen',
    'faq': 'FAQ',
    'contact': 'Kontaktiere uns',
    'tos': 'Nutzungsbedingungen',
    'policy': 'Datenschutz-Bestimmungen'
  },
  'board': {
    'titlePlaceholder': 'Geben Sie einen Titel für diese Karte ein',
    'deleteDescription': 'Möchten Sie diese Karte wirklich löschen?',
    'editCard': 'Karte bearbeiten',
    'deleteCard': 'Karte löschen',
    'state': {
      'TODO': 'MACHEN',
      'INPROGRESS': 'IN BEARBEITUNG',
      'TESTING': 'TESTEN',
      'DONE': 'GETAN'
    }
  },
  'chat': {
    'online': 'Benutzer online ({count})',
    'addChannel': 'Kanal hinzufügen',
    'channel': 'Kanal | Kanäle',
    'message': 'Botschaft'
  },
  'email': {
    'compose': 'E-Mail verfassen',
    'send': 'Senden',
    'subject': 'Gegenstand',
    'labels': 'Etiketten',
    'emptyList': 'Leere E-Mail-Liste',
    'inbox': 'Posteingang',
    'sent': 'Geschickt',
    'drafts': 'Entwürfe',
    'starred': 'Markiert',
    'trash': 'Müll',
    'work': 'Arbeit',
    'invoice': 'Rechnung'
  },
  'todo': {
    'addTask': 'Aufgabe hinzufügen',
    'tasks': 'Aufgaben',
    'completed': 'Abgeschlossen',
    'labels': 'Etiketten'
  },
  'dashboard': {
    'activity': 'Aktivität',
    'weeklySales': 'Wöchentliche Verkäufe',
    'sales': 'Der Umsatz',
    'recentOrders': 'letzte Bestellungen',
    'sources': 'Verkehrsquellen',
    'lastweek': 'gegen letzte Woche',
    'orders': 'Aufträge',
    'customers': 'Kunden',
    'tickets': 'Support-Tickets',
    'viewReport': 'Zeige Bericht'
  },
  'usermenu': {
    'profile': 'Profil',
    'signin': 'Anmelden',
    'dashboard': 'Instrumententafel',
    'signout': 'Ausloggen'
  },
  'error': {
    'notfound': 'Seite nicht gefunden',
    'other': 'Ein Fehler ist aufgetreten'
  },
  'check': {
    'title': 'Neues Passwort festlegen',
    'backtosign': 'Zurück zur Anmeldung',
    'newpassword': 'Neues Passwort',
    'button': 'Legen Sie ein neues Passwort fest und melden Sie sich an',
    'error': 'Der Aktionslink ist ungültig',
    'verifylink': 'Link überprüfen ...',
    'verifyemail': 'E-Mail-Adresse überprüfen ...',
    'emailverified': 'Email überprüft! Umleiten ...'
  },
  'forgot': {
    'title': 'Passwort vergessen?',
    'subtitle': 'Geben Sie die E-Mail-Adresse Ihres Kontos ein und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.',
    'email': 'Email',
    'button': 'Fordere Passwort-Reset an',
    'backtosign': 'Zurück zur Anmeldung'
  },
  'login': {
    'title': 'Anmelden',
    'email': 'Email',
    'password': 'Passwort',
    'button': 'Anmelden',
    'orsign': 'Oder melden Sie sich mit an',
    'forgot': 'Passwort vergessen?',
    'noaccount': 'Sie haben noch keinen Account?',
    'create': 'Erstellen Sie hier eine',
    'error': 'Die E-Mail / Passwort-Kombination ist ungültig'
  },
  'register': {
    'title': 'Benutzerkonto anlegen',
    'name': 'Vollständiger Name',
    'email': 'Email',
    'password': 'Passwort',
    'button': 'Benutzerkonto anlegen',
    'orsign': 'Oder melden Sie sich an mit',
    'agree': 'Mit Ihrer Anmeldung stimmen Sie dem zu',
    'account': 'Sie haben bereits ein Konto?',
    'signin': 'Anmelden'
  },
  'utility': {
    'maintenance': 'In Wartung'
  },
  'faq': {
    'call': 'Haben Sie weitere Fragen? Bitte erreichen Sie'
  },
  'ecommerce': {
    'products': 'Produkte',
    'filters': 'Filter',
    'collections': 'Sammlungen',
    'priceRange': 'Preisklasse',
    'customerReviews': 'Kundenbewertungen',
    'up': 'und auf',
    'brand': 'Marke',
    'search': 'Nach Produkt suchen',
    'results': 'Ergebnisse ({0} von {1})',
    'orders': 'Aufträge',
    'shipping': 'Versand',
    'freeShipping': 'Kostenloser Versand',
    'inStock': 'Auf Lager',
    'quantity': 'Menge',
    'addToCart': 'In den Warenkorb legen',
    'buyNow': 'Kaufe jetzt',
    'price': 'Preis',
    'about': 'Über diesen Artikel',
    'description': 'Beschreibung',
    'reviews': 'Bewertungen',
    'details': 'Produktdetails',
    'cart': 'Wagen',
    'summary': 'Bestellübersicht',
    'total': 'Gesamt',
    'discount': 'Rabatt',
    'subtotal': 'Zwischensumme',
    'continue': 'Mit dem Einkaufen fortfahren',
    'checkout': 'Auschecken'
  },
  'menu': {
    'search': 'Suchen (drücken Sie \'Strg + /\', um zu fokussieren)',
    'dashboard': 'Instrumententafel',
    'logout': 'Ausloggen',
    'profile': 'Profil',
    'blank': 'Leere Seite',
    'pages': 'Seiten',
    'others': 'Andere',
    'email': 'Email',
    'chat': 'Plaudern',
    'todo': 'Machen',
    'board': 'Task Board',
    'users': 'Benutzer',
    'usersList': 'Liste',
    'usersEdit': 'Bearbeiten',
    'ecommerce': 'E-Commerce',
    'ecommerceList': 'Produkte',
    'ecommerceProductDetails': 'Produktdetails',
    'ecommerceOrders': 'Aufträge',
    'ecommerceCart': 'Wagen',
    'auth': 'Auth-Seiten',
    'authLogin': 'Anmelden / Anmelden',
    'authRegister': 'Anmelden / Registrieren',
    'authVerify': 'E-Mail bestätigen',
    'authForgot': 'Passwort vergessen',
    'authReset': 'Passwort zurücksetzen',
    'errorPages': 'Fehlerseiten',
    'errorNotFound': 'Nicht gefunden / 404',
    'errorUnexpected': 'Unerwartet / 500',
    'utilityPages': 'Hilfsseiten',
    'utilityMaintenance': 'Instandhaltung',
    'utilitySoon': 'Demnächst',
    'utilityHelp': 'FAQs / Hilfe',
    'levels': 'Menüebenen',
    'disabled': 'Menü deaktiviert',
    'docs': 'Dokumentation',
    'feedback': 'Feedback',
    'support': 'Unterstützung',
    'landingPage': 'Landing Page',
    'pricingPage': 'Preisseite'
  },
  '$vuetify': {
    'badge': 'Abzeichen',
    'close': 'Schließen',
    'dataIterator': {
      'noResultsText': 'Keine übereinstimmenden Aufzeichnungen gefunden',
      'loadingText': 'Artikel laden ...'
    },
    'dataTable': {
      'itemsPerPageText': 'Zeilen pro Seite:',
      'ariaLabel': {
        'sortDescending': 'Absteigend sortiert.',
        'sortAscending': 'Aufsteigend sortiert.',
        'sortNone': 'Nicht sortiert.',
        'activateNone': 'Aktivieren Sie diese Option, um die Sortierung zu entfernen.',
        'activateDescending': 'Aktivieren Sie diese Option, um absteigend zu sortieren.',
        'activateAscending': 'Aktivieren Sie diese Option, um aufsteigend zu sortieren.'
      },
      'sortBy': 'Sortieren nach'
    },
    'dataFooter': {
      'itemsPerPageText': 'Objekte pro Seite:',
      'itemsPerPageAll': 'Alle',
      'nextPage': 'Nächste Seite',
      'prevPage': 'Vorherige Seite',
      'firstPage': 'Erste Seite',
      'lastPage': 'Letzte Seite',
      'pageText': '{0} - {1} von {2}'
    },
    'datePicker': {
      'itemsSelected': '{0} ausgewählt',
      'nextMonthAriaLabel': 'Nächsten Monat',
      'nextYearAriaLabel': 'Nächstes Jahr',
      'prevMonthAriaLabel': 'Vorheriger Monat',
      'prevYearAriaLabel': 'Vorheriges Jahr'
    },
    'noDataText': 'Keine Daten verfügbar',
    'carousel': {
      'prev': 'Vorheriges Bild',
      'next': 'Nächstes Bild',
      'ariaLabel': {
        'delimiter': 'Karussell Folie {0} von {1}'
      }
    },
    'calendar': {
      'moreEvents': '{0} mehr'
    },
    'fileInput': {
      'counter': '{0} Dateien',
      'counterSize': '{0} Dateien (insgesamt {1})'
    },
    'timePicker': {
      'am': 'AM',
      'pm': 'PM'
    },
    'pagination': {
      'ariaLabel': {
        'wrapper': 'Paginierungsnavigation',
        'next': 'Nächste Seite',
        'previous': 'Vorherige Seite',
        'page': 'Gehe zu Seite {0}',
        'currentPage': 'Aktuelle Seite, Seite {0}'
      }
    }
  }
}